/**
 * Dashboard 服务 - getArtistDashboard
 *
 * USE_MOCK 为 true 时使用本地 mock；联调改为 false 走 rpc/getArtistDashboard。
 */
import type { ApiResponse } from '@common/api';
import { getArtistDashboard } from '@services';
import type { GetArtistDashboardResult } from '@services/types';

function unwrapGetArtistDashboardResponse(
  res: unknown
): GetArtistDashboardResult {
  if (res == null || typeof res !== 'object') {
    throw new Error('getArtistDashboard: empty response');
  }
  const r = res as ApiResponse<GetArtistDashboardResult> & GetArtistDashboardResult;
  // @phx/ads-api 可能直接返回 data 体，或标准 { code, msg, data }
  if ('code' in r && typeof r.code === 'number' && 'data' in r) {
    if (r.code !== 0) {
      throw new Error(r.msg || 'getArtistDashboard failed');
    }
    return r.data;
  }
  return res as unknown as GetArtistDashboardResult;
}

const USE_MOCK = false;

const MOCK_DASHBOARD: GetArtistDashboardResult = {
  artistStats: {
    plays: 651_000,
    likes: 45_900,
    shares: 1_200,
    downloads: 3_200,
  },
  musicList: [
    {
      musicID: 'mock-1',
      artistID: '',
      title: 'Born Survivor',
      cover: '',
      publishTime: Math.floor(Date.now() / 1000) - 86400 * 45,
      musicStatus: 1,
      plays: 125_000,
      likes: 8_200,
      shares: 340,
      downloads: 1_200,
      genre: [1],
      producer: 'K_Moneystain',
    },
    {
      musicID: 'mock-2',
      artistID: '',
      title: 'Night Life',
      cover: '',
      publishTime: Math.floor(Date.now() / 1000) - 86400 * 20,
      musicStatus: 1,
      plays: 89_400,
      likes: 5_600,
      shares: 210,
      downloads: 890,
      genre: [1, 11],
      producer: 'Studio North',
    },
    {
      musicID: 'mock-3',
      artistID: '',
      title: 'Summer Vibes',
      cover: '',
      publishTime: Math.floor(Date.now() / 1000) - 86400 * 7,
      musicStatus: 1,
      plays: 45_200,
      likes: 3_100,
      shares: 98,
      downloads: 412,
      genre: [11],
      producer: '—',
    },
    {
      musicID: 'mock-4',
      artistID: '',
      title: 'Midnight Run',
      cover: '',
      publishTime: Math.floor(Date.now() / 1000) - 86400 * 2,
      musicStatus: 1,
      plays: 892,
      likes: 64,
      shares: 12,
      downloads: 5,
      genre: [1],
      producer: 'Local Mock',
      featuredArtist: ['Feat. Guest'],
    },
  ],
};

export const fetchArtistDashboard = async (artistID: string): Promise<GetArtistDashboardResult> => {
  if (USE_MOCK) {
    return {
      ...MOCK_DASHBOARD,
      musicList: MOCK_DASHBOARD.musicList.map((item) => ({
        ...item,
        artistID: item.artistID || artistID,
      })),
    };
  }

  const res = await getArtistDashboard({ artistID });
  return unwrapGetArtistDashboardResponse(res);
};
